export default {"src":"/_next/static/media/footerLogo4.de6b3ab2.svg","height":45,"width":103,"blurWidth":0,"blurHeight":0};